module.exports = __webpack_public_path__ + "2bbe6b846f23b08b863b5c4efc57c19a.svg";